/* =========================================================
  CBD HUT — theme runtime globals
  - Reads the JSON blob from #cbh-theme-data
  - Assigns shared routes and translated strings
  - Adds a Theme Editor helper class
  Third-party apps are initialised by their official app embeds.
========================================================= */

(() => {
  const element = document.getElementById('cbh-theme-data');
  if (!element) return;

  let data;
  try {
    data = JSON.parse(element.textContent || '{}');
  } catch (error) {
    return;
  }

  window.CBH_THEME = data;

  if (window.Shopify?.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
  }

  if (data.shopUrl && !window.shopUrl) window.shopUrl = data.shopUrl;
  if (data.routes && !window.routes) window.routes = data.routes;
  if (data.cartStrings && !window.cartStrings) window.cartStrings = data.cartStrings;
  if (data.variantStrings && !window.variantStrings) window.variantStrings = data.variantStrings;
  if (data.quickOrderListStrings && !window.quickOrderListStrings) {
    window.quickOrderListStrings = data.quickOrderListStrings;
  }
  if (data.accessibilityStrings && !window.accessibilityStrings) {
    window.accessibilityStrings = data.accessibilityStrings;
  }
})();
